/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
import {
  takeLatest, put, call,
} from 'redux-saga/effects';
import api from 'store/api';
import { toast } from 'react-toastify';
import { URL } from '../../../constants/url';
import actionTypes from '../actionTypes';

export function* getMistakes({ payload }) {
  const {
    limit,
    stackSize,
    position,
    category,
    game,
    ggps,
    isFreeUser,
    difficulty,
  } = payload;
  try {
    const payloadPosition = (position.length === 1 && position[0].includes('random')) ? (position[0] === 'randomRfiNoBlinds' ? ['noblinds'] : []) : position;
    const defineEndpoint = () => {
      if (sessionStorage.getItem('isPlo5') === 'true') return URL.GET_MISTAKESPLO5;
      if (isFreeUser) return URL.GET_MISTAKES_FREE;
      return URL.GET_MISTAKES;
    };

    const res = yield call(api, {
      method: 'post',
      url: defineEndpoint(),
      data: {
        bb: stackSize.value,
        ts: limit.value,
        position: payloadPosition,
        category: category.value.toLowerCase().replace(' ', ''),
        game,
        gg: ggps === 'gg',
        difficulty,
      },
    });
    yield put({ type: 'GET_MISTAKES_SUCCESS', payload: res.data });
  } catch (e) {
    if (e.message !== 'token contains an invalid number of segments') {
      yield call(toast.error, e.message);
    }
    yield put({ type: 'GET_MISTAKES_ERROR' });
  }
}

export default function* listener() {
  yield takeLatest([actionTypes.GET_MISTAKES, 'GET_MISTAKES_CLEAR'], function* handleRequest(action) {
    if (action.type === actionTypes.GET_MISTAKES) yield call(getMistakes, action);
  });
}
